import { Controller } from "@hotwired/stimulus"
import { shareText } from "../lib/share_text"

// Modal da lista de jogos: a pessoa marca quais jogos entram na mensagem e o
// texto é montado a partir dos data-day / data-line de cada checkbox (já
// formatados no servidor por ShareMessage). Montar no cliente — em vez de
// buscar o texto num endpoint — mantém o compartilhamento dentro do toque do
// usuário, que é o que o Safari exige pra abrir a folha nativa.
export default class extends Controller {
  static targets = ["dialog", "checkbox", "send", "count"]
  static values = { title: String, url: String }

  open() {
    this.dialogTarget.showModal()
    this.update()
  }

  close() {
    this.dialogTarget.close()
  }

  selectAll() {
    this.checkboxTargets.forEach((box) => (box.checked = true))
    this.update()
  }

  clear() {
    this.checkboxTargets.forEach((box) => (box.checked = false))
    this.update()
  }

  update() {
    const selected = this.checkboxTargets.filter((box) => box.checked).length
    this.countTarget.textContent = selected
    this.sendTarget.disabled = selected === 0
  }

  async send() {
    await shareText(this.message())
    this.close()
  }

  message() {
    const days = []
    this.checkboxTargets.filter((box) => box.checked).forEach((box) => {
      const last = days[days.length - 1]
      if (last && last.day === box.dataset.day) last.lines.push(box.dataset.line)
      else days.push({ day: box.dataset.day, lines: [box.dataset.line] })
    })

    const body = days.map((entry) => [entry.day, ...entry.lines].join("\n\n")).join("\n\n")
    return [this.titleValue, body, this.urlValue].join("\n\n")
  }
}
